import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import PropTypes from "prop-types";
import { equals } from "ramda";
import { Flex, Checkbox, Fieldset } from "@base-ui";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
var CheckboxFieldset = function CheckboxFieldset(props) {
  var id = props.id,
    legend = props.legend,
    hideLegend = props.hideLegend,
    name = props.name,
    options = props.options,
    updateSelected = props.updateSelected,
    icon = props.icon,
    className = props.className,
    ellipse = props.ellipse;
  var checkboxes = options.map(function (option) {
    return /*#__PURE__*/_jsx(Checkbox, {
      id: "".concat(id, "-checkbox-").concat(option.id),
      label: option.label,
      disabled: option.disabled,
      checked: option.checked,
      name: name,
      onChange: function onChange(check) {
        return updateSelected(check, option.id);
      },
      ellipse: ellipse
    }, option.id);
  });
  return /*#__PURE__*/_jsx(Fieldset, _objectSpread(_objectSpread({
    legend: legend,
    hideLegend: hideLegend,
    className: className
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    icon: icon,
    children: /*#__PURE__*/_jsx(Flex.Column, {
      style: {
        width: "inherit"
      },
      children: checkboxes
    })
  }));
};
CheckboxFieldset.propTypes = {
  id: PropTypes.string.isRequired,
  legend: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  updateSelected: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  hideLegend: PropTypes.oneOf([true, false]),
  icon: PropTypes.string,
  ellipse: PropTypes.oneOf([true, false])
};
CheckboxFieldset.defaultProps = {
  hideLegend: false,
  ellipse: false
};
export default /*#__PURE__*/memo(CheckboxFieldset, function (prev, curr) {
  return equals(prev.options, curr.options);
});